export default "__VITE_ASSET__BZEQMMr1__"